import { NgModule } from '@angular/core';
import { MyReturnRoutingModule } from './my-return-routing.module';
import { SharedModule } from '@app/shared/shared.module';
import * as fromComponents from './components';
import { CommonModule } from '@angular/common';
import { MyReturnComponent } from '@app/my-return/my-return.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CanLeaveModule } from '@app/can-leave/can-leave.module';
import { ReturnSaveConfirmComponent } from './components/return-save-confirm/return-save-confirm.component';

/**
 * MyReturnModule
 */
@NgModule({
  imports: [
    SharedModule,
    MyReturnRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    CanLeaveModule,
  ],
  declarations: [
    MyReturnComponent,
    ...fromComponents.components,
    ReturnSaveConfirmComponent,
  ],
  providers: [],
  exports: [MyReturnComponent, ...fromComponents.components],
})
export class MyReturnModule {}
